import axios from "axios";

//  const API_URL = 'https://apilava.thecoderspottest.com/api/v1/admin/';
//  const API_URL = 'http://localhost:3000/api/v1/admin/';
 const API_URL = 'https://api.globalcoatings.app/api/v1/admin/';
// localhost
// const API_URL = "http://localhost:3000/api/v1/admin/";

export const GOOGLE_MAP_KEY = 'AIzaSyB2extZ7r3WnxIgwLY83LV5cZSqFb5h7N8';

export const GOOGLE_LIBRARIES = ['places'];

export const numbersCheck= /^[+]?[0-9]+$/;
export const characterCheck = /^[A-Za-z_ ]+$/;

export function setAxiosDefault(){
	return getToken()
	.then(resp => {
		console.log('resp',resp)
		var token = resp;
		axios.defaults.headers.common['Authorization'] = token;
		axios.defaults.headers.common['Content-Type'] = "multipart/form-data";
		
		return token
	}).catch(err => {
        console.log('error in setAxios', err)
	});
}

const handleError = (error) => {
	console.log(error);
	//console.log(error);
    if(error.response.status == 400) {
        return;
    }
	if(error.response.status == 413) {
		console.log(error)
        return;
    }
	if(error.response.status == 401){
		console.log('logged out');
		// let route = useRoute();
		// let redirectRoute = (RootNavigation.getCurrentRoute()).name;
		//return setToken("")
        localStorage.setItem("lava20_admin", '');
		document.location.reload();
		return;
		// .then(resp => {
			// var token = resp;
			// axios.defaults.headers.common['Authorization'] = "Bearer "+token;
			//source.cancel('optional message')
			//RootNavigation.navigate('Login', { routeName: redirectRoute });
		// }).catch(err => {

		// });
	}
	if(error.response.status == 422){
		// alert(error.response.data.error);
		//alertMessagePopupErr('error', 'Validation Error', error.response.data)
      	return;
	}
};

export function signin(data){

	return axios.post(API_URL + 'login', data)
  	.then( response => {
  		// Do not log the response: it carries mfa_token / session token.
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		handleError(err);
		return Promise.reject(err);
  	});

}

// ---------------------------------------------------------------------------
// Admin TOTP (two-step login). Spec: docs/superpowers/specs/2026-09-18-admin-totp-design.md §4
// All three take the short-lived `mfa_token` returned by POST /login (never the session token).
// These routes answer 400/429 (never 401) with {status:false, message, code} — the caller maps
// the codes (INVALID_CREDENTIALS, MFA_CODE_INVALID, MFA_LOCKED, MFA_TOKEN_EXPIRED, RATE_LIMITED).
// `handleError` is only consulted when there is an HTTP response (it returns on 400) so a
// network failure is rejected with the original error instead of a TypeError.
// ---------------------------------------------------------------------------

// POST /admin/mfa/enroll/start  {mfa_token}  → {status:true, otpauth_url, qr_data_url, manual_key}
export function adminMfaEnrollStart(mfaToken){

	return axios.post(API_URL + 'mfa/enroll/start', { mfa_token: mfaToken })
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError(err);
		return Promise.reject(err);
  	});

}

// POST /admin/mfa/enroll/confirm  {mfa_token, code}  → {status:true, token, backup_codes:[...10]}
export function adminMfaEnrollConfirm(mfaToken, code){

	return axios.post(API_URL + 'mfa/enroll/confirm', { mfa_token: mfaToken, code: code })
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError(err);
		return Promise.reject(err);
  	});

}

// POST /admin/mfa/verify  {mfa_token, code}  → {status:true, token}
// `code` is either a 6-digit TOTP or a backup code in the form XXXX-XXXX.
export function adminMfaVerify(mfaToken, code){

	return axios.post(API_URL + 'mfa/verify', { mfa_token: mfaToken, code: code })
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError(err);
		return Promise.reject(err);
  	});

}

export function add_edit_contractor(data){

    // return setAxiosDefault().then(r => {
	// 	return axios.post(API_URL + 'add-edit-contractor', data)
	//   	.then( response => {
	//   		console.log(response.data);
	//   		return response.data;
	//   	})
	//   	.catch( err => {
	// 		// // console.log('Error  Login:', err)
	// 		// handleError(err);
	// 		handleError(err);
	// 		return Promise.reject(err);
	//   	});
  	// });
	let token = getToken()
	return axios.post(API_URL + 'add-edit-contractor', data, {
        headers : {
            'Content-Type': "multipart/form-data",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function getContractor(data, query, sortBy){

 let offset = (data-1)*10

	let token = getToken()
	return axios.get(API_URL + `get-contractor?offset=${offset}&query=${query}&sort=${sortBy}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
	
		handleError(err);
		return Promise.reject(err);
  	});

}

export function getSearchContractor(contractorId){

   
	   let token = getToken()
	   return axios.get(API_URL + `get-all-contractor?query=${contractorId}`, {
		   headers: {
			   'Authorization': token
		   }
	   })
		 .then( response => {
			 console.log(response.data);
			 return response.data;
		 })
		 .catch( err => {
	   
		   handleError(err);
		   return Promise.reject(err);
		 });
   
   }

export function getSingleContractor(data){
   
    let token = getToken()
	   return axios.get(API_URL + `get-contractor/${data}`, {
		headers: {
			'Authorization': token
		}
	   })
		 .then( response => {
			 console.log(response.data);
			 return response.data;
		 })
		 .catch( err => {
	   
		   handleError(err);
		   return Promise.reject(err);
		 });
   
   }

   export function verifyContractor(data, status){
     
    let token = getToken()
	   return axios.put(API_URL + `update-contractor-verify-status/${data}/${status}`,{}, {
		headers: {
			'Authorization': token
		}
	   })
		 .then( response => {
			 console.log(response.data);
			 return response.data;
		 })
		 .catch( err => {
	   
		   handleError(err);
		   return Promise.reject(err);
		 });
   
   }
   

export function deleteContractor(data){

	let token = getToken()
	return axios.delete(API_URL + `delete-contractor/${data}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function updateContractorStatus(id, status){
	
	let token = getToken()
	return axios.put(API_URL + `update-contractor-status/${id}/${status}`,{}, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function getContractorEmployee(page, id){

	let offset = (page-1)*10
    let token = getToken()
	return axios.get(API_URL + `get-contractor-employee?offset=${offset}&contractor_id=${id}`, {
		headers: {
			'Authorization': token
		}
	})
	  .then( response => {
		  console.log(response.data);
		  return response.data;
	  })
	  .catch( err => {
	
		handleError(err);
		return Promise.reject(err);
	  });

}

export function getContractorProject(page, id, query){

	let offset = (page-1)*10
    let token = getToken()
	return axios.get(API_URL + `get-contractor-project?offset=${offset}&contractor_id=${id}&query=${query}`, {
		headers: {
			'Authorization': token
		}
	})
	  .then( response => {
		  console.log(response.data);
		  return response.data;
	  })
	  .catch( err => {
	
		handleError(err);
		return Promise.reject(err);
	  });

}

export function add_edit_project(data){

	let token = getToken()
	return axios.post(API_URL + 'add-edit-project', data, {
        headers : {
            'Content-Type': "multipart/form-data",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function getProject(data){

	let offset = (data.page-1)*24;
	let token = getToken()
	const params = new URLSearchParams({
		offset: String(offset),
		filter: data.filter ?? '',
		roof: data.roof_type ?? '',
		sort: data.sortBy ?? '',
		search: data.search ?? '',
		contractor_id: data.contractor_id ?? '',
		date_type: data.date_type ?? '',
		date_from: data.date_from ?? '',
		date_to: data.date_to ?? '',
		show_nogo: data.show_nogo ?? ''
	});
	return axios.get(`${API_URL}get-project?${params.toString()}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function deleteProject(data){

	let token = getToken()
	return axios.delete(API_URL + `delete-project/${data}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
	
		handleError(err);
		return Promise.reject(err);
  	});

}



export function markNoGoApi(data){

	let token = getToken()
	return axios.get(API_URL + `nogo-project/${data}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
	
		handleError(err);
		return Promise.reject(err);
  	});

}


export function getProjectById(data){
	let token = getToken()
	return axios.get(API_URL + `get-project/${data}`,{
		headers:{
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function get_project_employee(id, page){
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-project-employee/${id}?offset=${offset}`,{
		headers:{
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function get_project_feedback(id, roofId, page){
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-project-feedback/${id}/${roofId}?offset=${offset}`,{
		headers:{
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function get_all_project(){
	
	let token = getToken()
	return axios.get(API_URL + `get-all-project`,{
		headers:{
			'Authorization': token
		}
	})
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}


export function getRoofType(page){
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-roof-type?offset=${offset}`, {
		headers:{
			'Authorization': token
		}
	})
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function getRoofSubCategory(data){
    let page = 1;
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-roof-type-sub-category?offset=${offset}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function add_roof_type(data){

	let token = getToken()
	return axios.post(API_URL + `add-edit-roof-type`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}



export function deleteProjectSubCategoryApi(data){

	let token = getToken()
	return axios.post(API_URL + `delete-project-subcategory`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function deleteRoofAttachmentApi(data){
	let token = getToken()
	return axios.post(API_URL + `delete-roof-attachment`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		 handleError(err);
		return Promise.reject(err);
  	});
}

export function publishProjectApi(data){

	let token = getToken()
	return axios.post(API_URL + `publish-project`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}


export function unpublishProjectApi(data){

	let token = getToken()
	return axios.post(API_URL + `unpublish-project`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});
}

export function finishProjectApi(data){

	let token = getToken()
	let projectID = data.project_id;
	return axios.post(API_URL + `update-finish-status/${projectID}`, data, {
		headers : {
			'Content-Type': "application/json",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});
}

export function add_roof_type_sub_category(data){

	let token = getToken()
	return axios.post(API_URL + `add-edit-roof-type-sub-category`, data, {
        headers : {
            'Content-Type': "application/json",
			'Authorization': token
        }
    })
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function addProjectRoofData(data){
	let token = getToken()
	return axios.post(API_URL + 'add-project-roof-data', data, {
        headers : {
            'Content-Type': "multipart/form-data",
			'Authorization': token
        }
    })
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function editProjectRoofData(data){
	let token = getToken()
	return axios.post(API_URL + 'edit-project-roof-data', data, {
        headers : {
            'Content-Type': "multipart/form-data",
			'Authorization': token
        }
    })
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		// // console.log('Error  Login:', err)
		 handleError(err);
		return Promise.reject(err);
  	});

}

export function add_project_contractor(data, projectId){

	let token = getToken();

	return axios.post(API_URL + `add-project-contractor/${projectId}`, data, {
		headers: {
			'Content-Type': "application/json",
			'Authorization': token
		}
	} )
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});

}

export function get_contractor_video(page, title, sort){
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-contractor-video?offset=${offset}&title=${title}&sort=${sort}`, {
		headers: {
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});


}

export function get_employee_video(page, title, sort){
	let offset = (page-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-employee-video?offset=${offset}&title=${title}&sort=${sort}`, {
		headers: {
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});


}

export function add_contractor_video(data){
	
	let token = getToken()
	return axios.post(API_URL + `add-edit-contractor-video`, data,{
		headers: {
			'Content-Type': "multipart/form-data",
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});
}

export function add_employee_video(data){
	
	let token = getToken()
	return axios.post(API_URL + `add-edit-employee-video`, data,{
		headers: {
			'Content-Type': "multipart/form-data",
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});


}

export function delete_employee_video(id){
	
	let token = getToken()
	return axios.delete(API_URL + `delete-employee-video/${id}`, {
		headers: {
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});


}
export function delete_contractor_video(id){
	
	let token = getToken()
	return axios.delete(API_URL + `delete-contractor-video/${id}`, {
		headers: {
			'Authorization': token
		}
	} )
  	.then( response => {
  		//console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		
		handleError(err);
		return Promise.reject(err);
  	});


}


function getToken() {
    return localStorage.getItem('lava20_admin');
  }

export function getDashboardStats(){
	let token = getToken()
	return axios.get(API_URL + `dashboard-stats`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function addProgressMediaApi(projectId, data){
	let token = getToken()
	return axios.post(API_URL + `add-progress-media/${projectId}`, data, {
		headers: {
			'Content-Type': "multipart/form-data",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function deleteProgressMediaApi(projectId, mediaId){
	let token = getToken()
	return axios.delete(API_URL + `delete-progress-media/${projectId}/${mediaId}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function addProjectDocumentsApi(projectId, data){
	let token = getToken()
	return axios.post(API_URL + `add-project-documents/${projectId}`, data, {
		headers: {
			'Content-Type': "multipart/form-data",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function deleteProjectDocumentApi(projectId, docIndex){
	let token = getToken()
	return axios.delete(API_URL + `delete-project-document/${projectId}/${docIndex}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function addEmployeeToProjectApi(projectId, data){
	let token = getToken()
	return axios.post(API_URL + `add-employee-to-project/${projectId}`, data, {
		headers: {
			'Content-Type': "application/json",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function removeEmployeeFromProjectApi(projectId, employeeId){
	let token = getToken()
	return axios.delete(API_URL + `remove-employee-from-project/${projectId}/${employeeId}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function getAssignedEmployeesApi(){
	let token = getToken()
	return axios.get(API_URL + `get-assigned-employees`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function getEmployee(data, query, sortBy){
	let offset = (data-1)*10
	let token = getToken()
	return axios.get(API_URL + `get-employee?offset=${offset}&query=${encodeURIComponent(query || '')}&sort=${sortBy}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function createEmployee(data){
	let token = getToken()
	return axios.post(API_URL + 'create-employee', data, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function getEmployeeById(id){
	let token = getToken()
	return axios.get(API_URL + `get-employee-by-id/${id}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

// PUT admin/update-employee/:id (JSON). Keys are optional: absent = unchanged, '' or null = clear.
// The request body can carry the PPS, so handleError (which console.logs its argument) only
// receives the response status and body, never the axios error with its request config.
// A network failure has no response and is rejected with the original error.
export function updateEmployee(id, payload){
	let token = getToken()
	return axios.put(API_URL + `update-employee/${id}`, payload, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

// GET admin/employee-holiday-balance/:employee_id[?year=YYYY]. Answers { status, data: { year,
// holiday: { allowance, used, used_computed, used_override, pending, remaining,
// remaining_after_pending }, sick: { used, pending } } }. The year defaults to the current one on
// the server. As in updateEmployee, handleError only receives the response status and body.
export function getEmployeeHolidayBalance(id, year){
	let token = getToken()
	const query = year ? `?year=${encodeURIComponent(year)}` : ''
	return axios.get(API_URL + `employee-holiday-balance/${id}${query}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

// Employee training certificates (admin). Every call answers { status, message, data: [certificate] }.
// The upload body is multipart (file, title, expires_at): axios sets the boundary itself, so no
// Content-Type is passed. As in updateEmployee, handleError only receives the response status and
// body, never the axios error with its request config, and a network failure is rejected as is.
export function getEmployeeCertificates(id){
	let token = getToken()
	return axios.get(API_URL + `employee-certificates/${id}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

export function uploadEmployeeCertificate(id, formData){
	let token = getToken()
	return axios.post(API_URL + `employee-certificates/${id}`, formData, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

export function updateEmployeeCertificate(id, certId, payload){
	let token = getToken()
	return axios.patch(API_URL + `employee-certificates/${id}/${certId}`, payload, {
		headers: {
			'Content-Type': 'application/json',
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

export function deleteEmployeeCertificate(id, certId){
	let token = getToken()
	return axios.delete(API_URL + `employee-certificates/${id}/${certId}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		if (err && err.response) handleError({ response: { status: err.response.status, data: err.response.data } });
		return Promise.reject(err);
  	});
}

export function deleteEmployeeApi(id, deleteAllData){
	let token = getToken()
	return axios.delete(API_URL + `delete-employee/${id}?deleteAllData=${deleteAllData}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function sendEmployeePasswordEmail(id){
	let token = getToken()
	return axios.post(API_URL + `send-employee-password-email/${id}`, {}, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function setupEmployeePassword(data){
	return axios.post('https://api.globalcoatings.app/api/v1/employee/setup-password', data, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
  	.then( response => {
  		return response.data;
  	})
  	.catch( err => {
		return Promise.reject(err);
  	});
}

// ============ TIMESHEET MANAGEMENT ============

export function getAllEmployeesForTimesheet(){
	let token = getToken()
	return axios.get(API_URL + `get-employee?offset=0&limit=0&query=&sort=name`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getTimesheetEntries(employeeId, from, to){
	let token = getToken()
	return axios.get(API_URL + `timesheet/${employeeId}?from=${from}&to=${to}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function editTimesheetEntry(entryId, data){
	let token = getToken()
	return axios.put(API_URL + `timesheet-entry/${entryId}`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function addTimesheetHolidaySick(data){
	let token = getToken()
	return axios.post(API_URL + `timesheet-holiday-sick`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function exportTimesheetPdf(employeeId, from, to){
	let token = getToken()
	return axios.get(API_URL + `timesheet-export-pdf/${employeeId}?from=${from}&to=${to}`, {
		headers: { 'Authorization': token },
		responseType: 'blob'
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function exportWhosInPdf(params = {}){
	let token = getToken()
	const qs = new URLSearchParams()
	if (params.date) qs.set('date', params.date)
	if (params.search) qs.set('search', params.search)
	if (params.locations && params.locations.length > 0) qs.set('locations', params.locations.join(','))
	const queryString = qs.toString()
	return axios.get(API_URL + 'whos-in-pdf' + (queryString ? '?' + queryString : ''), {
		headers: { 'Authorization': token },
		responseType: 'blob'
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getTimesheetLiveStatus(){
	let token = getToken()
	return axios.get(API_URL + `timesheet-live-status`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getTimesheetSummary(employeeId, from, to){
	let token = getToken()
	return axios.get(API_URL + `timesheet-summary/${employeeId}?from=${from}&to=${to}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function adminManualClockIn(data){
	let token = getToken()
	return axios.post(API_URL + `timesheet-manual-clock-in`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function adminManualClockOut(data){
	let token = getToken()
	return axios.post(API_URL + `timesheet-manual-clock-out`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getTimesheetCalendar(year){
	let token = getToken()
	return axios.get(API_URL + `timesheet-calendar?year=${year}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function deleteTimesheetHolidaySick(entryId){
	let token = getToken()
	return axios.delete(API_URL + `timesheet-holiday-sick/${entryId}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function resetTimesheetEntry(entryId){
	let token = getToken()
	return axios.delete(API_URL + `timesheet-entry/${entryId}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function clearTimesheetDay(entryId, reason){
	let token = getToken()
	return axios.delete(API_URL + `timesheet-entry/${entryId}/clear`, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token },
		data: { reason: reason || '' }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function addTimesheetHolidaySickRange(data){
	let token = getToken()
	return axios.post(API_URL + `timesheet-holiday-sick-range`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function addPricingMediaApi(projectId, data){
	let token = getToken()
	return axios.post(API_URL + `add-pricing-media/${projectId}`, data, {
		headers: {
			'Content-Type': "multipart/form-data",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function deletePricingMediaApi(projectId, mediaId){
	let token = getToken()
	return axios.delete(API_URL + `delete-pricing-media/${projectId}/${mediaId}`, {
		headers: {
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function promoteToDraftApi(projectId){
	let token = getToken()
	return axios.post(API_URL + `promote-to-draft`, { project_id: projectId }, {
		headers: {
			'Content-Type': "application/json",
			'Authorization': token
		}
	})
  	.then( response => {
  		console.log(response.data);
  		return response.data;
  	})
  	.catch( err => {
		handleError(err);
		return Promise.reject(err);
  	});
}

export function getTimesheetSettings(){
	let token = getToken()
	return axios.get(API_URL + `timesheet-settings`, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function updateTimesheetSettings(employeeId, data){
	let token = getToken()
	return axios.put(API_URL + `timesheet-settings/${employeeId}`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function updateClockInRadiusApi(projectId, clockInRadius){
	let token = getToken()
	return axios.post(API_URL + `update-clock-in-radius`, { project_id: projectId, clock_in_radius: clockInRadius }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function updateProjectStartDateApi(projectId, startDate){
	let token = getToken()
	return axios.put(API_URL + `project/${projectId}/start-date`, { start_date: startDate }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

// ===== Our Locations / Units =====

export function getTimesheetUnits(){
	let token = getToken()
	return axios.get(API_URL + `units`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function addTimesheetUnit(data){
	let token = getToken()
	return axios.post(API_URL + `units`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function updateTimesheetUnit(id, data){
	let token = getToken()
	return axios.put(API_URL + `units/${id}`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function deleteTimesheetUnit(id){
	let token = getToken()
	return axios.delete(API_URL + `units/${id}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

// ===== Stock Management — Products =====

export function getProducts(params = {}){
	let token = getToken()
	const qs = new URLSearchParams()
	if (params.query) qs.append('query', params.query)
	if (params.category) qs.append('category', params.category)
	if (params.offset != null) qs.append('offset', String(params.offset))
	if (params.include_inactive) qs.append('include_inactive', 'true')
	const q = qs.toString()
	return axios.get(API_URL + `products${q ? '?' + q : ''}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

// add/update use multipart (image optional — backend reads req.body fields + req.files.image)
export function addProduct(formData){
	let token = getToken()
	return axios.post(API_URL + `products`, formData, {
		headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function updateProduct(id, formData){
	let token = getToken()
	return axios.put(API_URL + `products/${id}`, formData, {
		headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function deleteProduct(id){
	let token = getToken()
	return axios.delete(API_URL + `products/${id}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function hardDeleteProduct(id){
	let token = getToken()
	return axios.post(API_URL + `products/${id}/hard-delete`, {}, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function adjustProductStock(id, data){
	let token = getToken()
	return axios.post(API_URL + `products/${id}/stock`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function uploadProductImage(id, formData){
	let token = getToken()
	return axios.post(API_URL + `products/${id}/image`, formData, {
		headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

// ===== Stock Management — Project Materials =====

export function calculateMaterials(data){
	let token = getToken()
	return axios.post(API_URL + `materials/calculate`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function attachProjectMaterials(projectId, data){
	let token = getToken()
	return axios.post(API_URL + `project/${projectId}/materials`, data, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function removeProjectMaterials(projectId){
	let token = getToken()
	return axios.delete(API_URL + `project/${projectId}/materials`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function applyProjectMaterialStock(projectId){
	let token = getToken()
	return axios.post(API_URL + `project/${projectId}/materials/apply-stock`, {}, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

// ===== Holiday Requests =====

export function getHolidayRequests(params = {}){
	let token = getToken()
	const qs = new URLSearchParams()
	if (params.status) qs.set('status', params.status)
	if (params.type) qs.set('type', params.type)
	if (params.contractor_id) qs.set('contractor_id', params.contractor_id)
	if (params.employee_id) qs.set('employee_id', params.employee_id)
	if (params.search) qs.set('search', params.search)
	if (params.from) qs.set('from', params.from)
	if (params.to) qs.set('to', params.to)

	// Pagination: backend uses offset only. Accept either {limit, offset} or {limit, page} from frontend.
	// Translate page→offset using effective limit (defaults 25 to match backend default).
	const limit = params.limit ? Number(params.limit) : 25
	if (params.limit) qs.set('limit', String(limit))
	if (params.offset !== undefined && params.offset !== null) {
		qs.set('offset', String(params.offset))
	} else if (params.page) {
		const page = Math.max(1, Number(params.page) || 1)
		qs.set('offset', String((page - 1) * limit))
	}

	const queryString = qs.toString()
	return axios.get(API_URL + 'holiday-requests' + (queryString ? '?' + queryString : ''), {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getHolidayRequestCounts(){
	let token = getToken()
	return axios.get(API_URL + 'holiday-requests/counts', {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function getHolidayRequestDetails(id){
	let token = getToken()
	return axios.get(API_URL + `holiday-requests/${id}`, {
		headers: { 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function approveHolidayRequest(id, comment){
	let token = getToken()
	return axios.put(API_URL + `holiday-requests/${id}/approve`, { comment: comment || '' }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function rejectHolidayRequest(id, comment){
	let token = getToken()
	return axios.put(API_URL + `holiday-requests/${id}/reject`, { comment: comment || '' }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function approveHolidayCancellation(id, comment){
	let token = getToken()
	return axios.put(API_URL + `holiday-requests/${id}/approve-cancellation`, { comment: comment || '' }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function rejectHolidayCancellation(id, comment){
	let token = getToken()
	return axios.put(API_URL + `holiday-requests/${id}/reject-cancellation`, { comment: comment || '' }, {
		headers: { 'Content-Type': 'application/json', 'Authorization': token }
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}

export function exportHolidayRequestPdf(id){
	let token = getToken()
	return axios.get(API_URL + `holiday-requests/${id}/pdf`, {
		headers: { 'Authorization': token },
		responseType: 'blob'
	})
	.then( response => { return response.data; })
	.catch( err => { handleError(err); return Promise.reject(err); });
}
